import React from 'react';
import PropTypes from 'prop-types';

import { texts } from 'utils/languages/fr';
import InfoBox from './InfoBox';
import DistributorEmailList from 'containers/communication/DistributorEmailList';

const CommunicationSection = ({ distributor }) => {
    return (
        <InfoBox title={texts.COMMUNICATIONS}>
            <DistributorEmailList
                emailsKey="distributorBillCCEmails"
                title={texts.COMPANY_EMAILS}
                distributor={distributor}
            />

            <DistributorEmailList
                emailsKey="reportingCCEmails"
                title={texts.REPORTING_EMAILS}
                distributor={distributor}
            />
            <DistributorEmailList
                emailsKey="capitalAccountCCEmails"
                title={texts.CAPITAL_ACCOUNTS_EMAILS}
                distributor={distributor}
            />
            <DistributorEmailList
                emailsKey="fundraisingCCEmails"
                title={texts.FUND_CALL_AND_DISTRIBUTION_EMAILS}
                distributor={distributor}
            />
            <DistributorEmailList
                emailsKey="subscriptionProcessCCEmails"
                title={texts.SUBSCRIPTION_PROGRESS_EMAILS}
                distributor={distributor}
            />
        </InfoBox>
    );
};

CommunicationSection.propTypes = { distributor: PropTypes.object };

export default CommunicationSection;
